import { lazy } from "react";

export { COMPANY_DOCUMENTS_PATH } from "./company-documents-path";
export const CompanyDocumentsPage = lazy(() => import("./company-documents"));
